import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-white/10 glass mt-20">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex items-center gap-3 font-bold text-xl text-white">
            <img 
              src="/app-icon.png" 
              alt="SwiftDev Toolkit" 
              className="w-8 h-8 rounded-lg"
            />
            <span className="tracking-tight">SwiftDev Toolkit</span>
          </div>
          <div className="flex items-center gap-8 text-sm text-slate-400">
            <Link 
              to="/privacy" 
              className="hover:text-white transition-all duration-300 hover:scale-105"
            >
              Privacy
            </Link>
            <Link 
              to="/terms" 
              className="hover:text-white transition-all duration-300 hover:scale-105"
            >
              Terms
            </Link>
            <a
              href="mailto:hello@swiftdevtoolkit.com"
              className="hover:text-white transition-all duration-300 hover:scale-105"
            >
              Contact
            </a>
          </div>
        </div>
        <div className="mt-10 text-center text-sm text-slate-500">
          © {new Date().getFullYear()} SwiftDev Toolkit. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
